'use es6';

import styled from 'styled-components';
const Whitespace = styled.div.withConfig({
  displayName: "Whitespace",
  componentId: "sc-1harrpu-0"
})(["height:", "px;"], props => props.height);
export default Whitespace;